import { render } from "./ProjectStageItemElement.vue?vue&type=template&id=473a61b8&ts=true"
import script from "./ProjectStageItemElement.vue?vue&type=script&lang=ts"
export * from "./ProjectStageItemElement.vue?vue&type=script&lang=ts"

import "./ProjectStageItemElement.vue?vue&type=style&index=0&id=473a61b8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QRadio,QBtn,QTooltip});
